import * as yup from 'yup';

/**
 * E.164 international phone number: optional leading '+', then 8-15 digits
 * starting with a non-zero country code (e.g. "+447911123456" or the
 * unmasked "447911123456" produced by the design-system PhoneInput).
 * Replaces mui-tel-input's matchIsValidTel, which required the MUI-based
 * dependency for country-aware validation.
 */
const isValidInternationalPhone = (value: string): boolean =>
  /^\+?[1-9]\d{7,14}$/.test(value.trim());

/**
 * Yup schema for optional phone number validation.
 * Accepts E.164 format (e.g., "+447911123456").
 * Empty strings are considered valid for optional fields.
 */
export const optionalPhoneSchema = yup
  .string()
  .test('valid-phone', 'Please enter a valid phone number', value => {
    if (!value || value.trim() === '') return true;
    return isValidInternationalPhone(value);
  })
  .transform(value => value || undefined);

/**
 * Yup schema for required phone number validation.
 * Accepts E.164 format (e.g., "+447911123456").
 */
export const requiredPhoneSchema = yup
  .string()
  .required('Phone number is required')
  .test('valid-phone', 'Please enter a valid phone number', value => {
    if (!value || value.trim() === '') return false;
    return isValidInternationalPhone(value);
  });
